import Facebook from "../../../public/homePage/footer/facebook.svg";
import Twitter from "../../../public/homePage/footer/twitter.svg";
import Instagram from "../../../public/homePage/footer/instagram.svg";
import Linkedin from "../../../public/homePage/footer/linkedin.svg";
import Youtube from "../../../public/homePage/footer/youtube.svg";

const socialUrls = [
  {
    name: "facebook",
    url: "https://www.facebook.com/E2E-Research-Services-Pvt-Ltd-176802042387757",
    icons: Facebook,
  },

  {
    name: "twitter",
    url: "https://twitter.com/E2EResearch",
    icons: Twitter,
  },
  // {
  //   name: "instagram",
  //   url: "https://www.instagram.com/e2eresearch",
  //   icons: Instagram,
  // },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/company/e2e-research-services",
    icons: Linkedin,
  },
  // {
  //   name: "youtube",
  //   url: "https://www.youtube.com/channel/UCRaO-pbPNrvc6txeORGDjSg/",
  //   icons: Youtube,
  // },
];

export default socialUrls;
